import React from 'react';
import PropTypes from 'prop-types';
import { entityType, filterFieldDataType, userDefaultFilterPropHiddenValue } from '../../constants';
import { filterPropsType } from '../../types/index';
import { localStorage } from '../../store';

export const FilteringContext = React.createContext();

class FilteringContextProvider extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    visibleColumns: PropTypes.array.isRequired,
    visibleFields: PropTypes.array.isRequired,
    actions: PropTypes.shape({
      initializeFiltering: PropTypes.func.isRequired,
      applyFilterAction: PropTypes.func.isRequired
    }).isRequired,
    entityType: PropTypes.string.isRequired,
    tableOptions: PropTypes.array.isRequired,
    filterProps: filterPropsType.isRequired
  };

  constructor(props) {
    super(props);

    const {
      parentId,
      actions,
      entityType,
      tableOptions,
      filterProps,
      defaultFilteredList,
      defaultFilteredListOverride,
      hazardList,
      buildingNum,
      dataViewId,
      userDefaultFilterProp,
      sharedDataView,
      selectedRows
    } = this.props;

    let { visibleColumns, visibleFields } = this.props;

    filterProps.filteredList = defaultFilteredList.result;
    filterProps.hazardList = hazardList;

    let dataViewFields = defaultFilteredList.fields;

    if (
      !!defaultFilteredListOverride &&
      typeof defaultFilteredListOverride !== 'undefined' &&
      defaultFilteredListOverride != null &&
      defaultFilteredListOverride.result.entityType === entityType
    ) {
      dataViewFields = defaultFilteredListOverride.fields;
      dataViewFields.filterValues = JSON.stringify(dataViewFields.filterValues);
      dataViewFields.latestDataViewId = defaultFilteredListOverride.dataViewId;
      filterProps.filteredList = defaultFilteredListOverride.result;
      visibleColumns = defaultFilteredListOverride.visibleColumns;
      visibleFields = defaultFilteredListOverride.visibleFields;

      localStorage.removeItem('defaultFilteredListOverride');
    }

    let filterValues =
      dataViewFields &&
      dataViewFields.filterValues != null &&
      dataViewFields.filterValues.length > 0
        ? JSON.parse(dataViewFields.filterValues)
        : null;

    if (filterValues != null) {
      Object.keys(filterValues).forEach(fieldKey => {
        if (filterValues[fieldKey] === null || filterValues[fieldKey]?.length === 0) {
          delete filterValues[fieldKey];
        }
      });
    }

    this.state = {
      filterState: {
        id: parentId,
        page: dataViewFields ? dataViewFields.page : 1,
        search: dataViewFields ? dataViewFields.search : '',
        visibleColumns: visibleColumns,
        visibleFields: visibleFields,
        sort: {
          sortField: dataViewFields ? dataViewFields.sortField : '',
          sortDirection: dataViewFields ? dataViewFields.sortDirection : ''
        },
        pageSize: dataViewFields ? dataViewFields.pageSize : 10,
        highlightedElementId: null,
        buildingNum: buildingNum,
        dataViewId: dataViewFields ? dataViewFields.latestDataViewId : null,
        filterValues: filterValues,
        filterLogicalOperator: 'AND',
        userDefaultFilterProp,
        sharedDataView
      },
      showingFilters: this.initializeShowingFilters(filterProps, visibleFields),
      actions,
      entityType,
      tableOptions,
      filterProps,
      selectedRows,
      dataViewId: dataViewId,
      handleFilterStateChanged: this.handleFilterStateChanged,
      handleApplyFiltering: this.handleApplyFiltering,
      setVisibleFields: this.setVisibleFields,
      updateMultipleSelectValues: this.updateMultipleSelectValues,
      handleChangeDataView: this.handleChangeDataView,
      setSelectedRows: this.setSelectedRows,
      handleDefaultFilteredListOverride: this.handleDefaultFilteredListOverride
    };
    //this.handleApplyFiltering({});
  }

  componentDidUpdate(oldProps, prevState) {
    const { filterProps: oldFilterProps } = oldProps;
    const { filterProps: newFilterProps } = this.props;
    if (JSON.stringify(oldFilterProps) !== JSON.stringify(newFilterProps)) {
      this.setState({ filterProps: newFilterProps });
    } else if (
      JSON.stringify(oldProps.defaultFilteredList) !==
      JSON.stringify(this.props.defaultFilteredList)
    ) {
      if ([entityType.inventory, entityType.product].includes(this.props.entityType)) {
        this.props.actions.getDataViewList(this.props.entityType);
      }
      this.props.actions.initializeFiltering(this.props.entityType);
      newFilterProps.filteredList = this.props.defaultFilteredList;
      this.setState({ filterProps: newFilterProps });
    }
  }

  initializeShowingFilters = (filterProps, visibleFields) => {
    const mapOptions = {};
    const mapValues = {};
    filterProps.possibleFieldsList.forEach(field => {
      if (field.filterType.type === filterFieldDataType.multiple_choice) {
        mapOptions[field.key] = field.filterType.options;
        mapValues[field.key] = [];
      }
    });

    return {
      multipleSelectOptions: mapOptions, //<----this is static, not necessary to be in state?
      multipleSelectValues: mapValues,
      visibleFields: visibleFields,
      visibleFieldsOriginal: visibleFields
    };
  };

  setVisibleFields = (newVisibleFields, values) => {
    this.setState(prevState => ({
      filterState: {
        ...prevState.filterState,
        visibleFields: newVisibleFields,
        filterValues: values
      },
      showingFilters: {
        ...prevState.showingFilters,
        visibleFields: newVisibleFields
      },
      visibleFields: newVisibleFields
    }));
  };

  //Used just in case when multiple choice filters are loaded from the data view
  updateMultipleSelectValues = values => {
    const mapValues = this.state.showingFilters.multipleSelectValues;
    this.props.visibleFields.forEach(field => {
      if (field.filterType.type === filterFieldDataType.multiple_choice) {
        if (values[field.key] !== undefined && values[field.key].length > 0) {
          mapValues[field.key] = values[field.key];
        }
      }
    });

    this.setState(oldState => ({
      showingFilters: {
        ...oldState.showingFilters,
        multipleSelectValues: mapValues
      }
    }));
    return mapValues;
  };

  handleFilterStateChanged = fieldValuePairs => {
    this.setState(prevState => ({
      filterState: {
        ...prevState.filterState,
        ...fieldValuePairs
      }
    }));
    const { actions, entityType } = this.props;
    const { filterState } = this.state;

    this.addDefaultFilterPropHiddenValue(filterState);

    actions.applyFilterAction(
      entityType,
      {
        ...filterState,
        ...fieldValuePairs
      },
      fieldValuePairs && fieldValuePairs.filterValues
        ? fieldValuePairs.filterValues
        : filterState.filterValues
    );
    if (typeof actions.clearSharedDataView === 'function') actions.clearSharedDataView();
  };

  handleApplyFiltering = values => {
    const { actions, entityType } = this.props;
    const { filterState } = this.state;
    filterState.page = 1;
    filterState.filterValues = values;
    this.addDefaultFilterPropHiddenValue(filterState);
    actions.applyFilterAction(entityType, filterState, values);
    if (typeof actions.clearSharedDataView === 'function') actions.clearSharedDataView();
  };

  addDefaultFilterPropHiddenValue = filterState => {
    if (
      filterState &&
      filterState.filterValues &&
      filterState.userDefaultFilterProp &&
      userDefaultFilterPropHiddenValue[filterState.userDefaultFilterProp]
    )
      filterState.filterValues[filterState.userDefaultFilterProp] =
        userDefaultFilterPropHiddenValue[filterState.userDefaultFilterProp];
  };

  handleChangeDataView = latestDataViewId => {
    const { actions, entityType, parentId, userDefaultFilterProp } = this.props;
    this.setState(prevState => ({
      filterState: {
        ...prevState.filterState,
        ...{ dataViewId: latestDataViewId }
      }
    }));
    actions.getDefaultDataView(entityType, parentId, latestDataViewId, userDefaultFilterProp);
    actions.getDataViewList(entityType);
  };

  setSelectedRows = selectedRows => {
    this.setState({ selectedRows: selectedRows });
  };

  handleDefaultFilteredListOverride = () => {
    const { filterProps } = this.props;

    localStorage.setItem(
      'defaultFilteredListOverride',
      JSON.stringify({
        fields: this.state.filterState,
        result: filterProps.filteredList,
        dataViewId: this.state.filterState.dataViewId,
        visibleColumns: this.state.filterState.visibleColumns,
        visibleFields: this.state.filterState.visibleFields
      })
    );
  };

  render() {
    const { children } = this.props;
    return <FilteringContext.Provider value={this.state}>{children}</FilteringContext.Provider>;
  }
}

export const wrapConsumer = Component =>
  function WrapperComponent(props) {
    return (
      <FilteringContext.Consumer>
        {context => <Component {...props} {...context} />}
      </FilteringContext.Consumer>
    );
  };

export default FilteringContextProvider;
